const MenuItems = [
  {
    name: 'Global Deals',
    getUrl: () => `/internal-dashboard/deals/`,
  },
  {
    name: 'Insurance Results',
    getUrl: () => `/internal-dashboard/insurance-results/`,
  },
  {
    name: 'Lending Results',
    getUrl: () => `/internal-dashboard/lending-results/`,
  },
  {
    name: 'Dealer Status',
    getUrl: () => `/internal-dashboard/dealer-status/`,
  },
  {
    name: 'Launch Status',
    getUrl: () => `/internal-dashboard/launch-status/`,
  },
  {
    name: 'Loan Status',
    getUrl: () => `/internal-dashboard/loan-status/`,
  },
];

export default () => MenuItems;
